module.exports = __webpack_public_path__ + "img/2023big4.0cf5ce00.png";